import styled from "styled-components";
import { Link } from "react-router-dom";

export const Button = styled.a`
	border-radius: 33px;
	background: ${({primary}) => (primary ? '#16A64E' : '#2783C6')};
	white-space: nowrap;
	padding: 12px 30px;
	color: ${({dark}) => (dark ? '#010606' : '#fff')};
	font-size: ${({fontBig}) => (fontBig ? '20px' : '16px')};
	outline: none;
	border: none;
	cursor: pointer;
  text-decoration: none;
	display: inline-block;
	justify-content: center;
	align-items: center;
  margin: 10px;
	transition: all 0.2s ease-in-out;

	&:hover{
		transition: all 0.2s ease-in-out;
		background: ${({primary}) => (primary? '#fff':'#o1BF71')};
	}
`
export const Button1 = styled(Link)`
	border-radius: 33px;
	background: 'none';
	white-space: nowrap;
	padding: 12px 30px;
	color: #16A64E;
	font-size: 16px;
	outline: none;
  text-decoration: none;
	border: 1px solid green;
	cursor: pointer;
  margin-left: 10px;
	display: inline-block;
	justify-content: center;
	align-items: center;
	transition: all 0.2s ease-in-out;

	&:hover{
		transition: all 0.2s ease-in-out;
		background: ${({primary}) => (primary? '#fff':'#o1BF71')};
	}
`
export const PreFooterButton = styled(Link)`
	border-radius: 33px;
	/* background: red; */
	white-space: nowrap;
	padding: 12px 30px;
	color: #16A64E;
	font-size: 16px;
	outline: none;
  text-decoration: none;
	border: 1px solid green;
	cursor: pointer;
  margin-left: 10px;
	display: inline-block;
	justify-content: center;
	align-items: center;
	transition: all 0.2s ease-in-out;
  background-image: url("images/googleplay.png");
  /* background-image: url(Apple); */
  background-repeat: no-repeat;

`